const TAG_CC = {
  id: 1,
  name: "CC",
  description: "Critical Care",
  colorHex: "#DB6561",
  position: 1,
};
const TAG_UC = {
  id: 2,
  name: "UC",
  description: "Urgent Care",
  colorHex: "#F2CB6B",
  position: 2,
};
const TAG_LG = {
  id: 3,
  name: "LG",
  description: "Liftgate",
  colorHex: "#679CB2",
  position: 50,
};
const TAG_LM = {
  id: 4,
  name: "LM",
  description: "Large Mark",
  colorHex: "#F465DA",
  position: 4,
};
const TAG_APTR = {
  id: 5,
  name: "APTR",
  description: "Appointment Required",
  colorHex: "#777DE9",
  position: 10,
};
const TAG_WC = {
  id: 6,
  name: "WC",
  description: "Will Call",
  colorHex: "#FFA500",
  position: 11,
};
const TAG_OSD = {
  id: 7,
  name: "OS&D",
  description: "Overage, Shortage or Damaged",
  colorHex: "#5271C6",
  position: 13,
};
const TAG_RSHP = {
  id: 82,
  name: "RSHP",
  description: "Reship",
  colorHex: "#3664A2",
  position: 210,
};

const shipment1 = {
  id: 136350665,
  proNumber: "2940391",
  pallets: 12,
  pieces: 24,
  handlingUnits: 8,
  weight: 16160,
  weightUnit: "lbs",
  serviceDue: "2026-03-17",
  appointmentDate: "2026-03-17T14:00:00",
  appointmentEndDate: "2026-03-17T16:00:00",
  location: "DYLT250821",
  sic: "ONT",
  status: "ARRV",
  shipper: { id: 93320, name: "TACO INC" },
  consignee: {
    id: 18452114,
    name: "RAYPAK",
    address: "2151 EASTMAN AVE",
    city: "SECAUCUS",
    state: "NJ",
    zipCode: "07094",
  },
  tags: [TAG_APTR, TAG_LG],
  isPlanned: true,
  sicTimeZone: "America/New_York",
};

const shipment2 = {
  id: 136355045,
  proNumber: "2940380",
  pallets: 6,
  pieces: 12,
  handlingUnits: 4,
  weight: 8320,
  weightUnit: "lbs",
  serviceDue: "2026-03-18",
  appointmentDate: null,
  appointmentEndDate: null,
  location: "DYLT250822",
  sic: "ONT",
  status: "PLAN",
  shipper: { id: 93321, name: "ACME CORP" },
  consignee: {
    id: 18452115,
    name: "JERSEY FREIGHT LLC",
    address: "100 HUDSON ST",
    city: "JERSEY CITY",
    state: "NJ",
    zipCode: "07302",
  },
  tags: [TAG_CC, TAG_APTR],
  isPlanned: true,
  sicTimeZone: "America/New_York",
};

const shipment3 = {
  id: 136358250,
  proNumber: "2940372",
  pallets: 3,
  pieces: 6,
  handlingUnits: 2,
  weight: 4200,
  weightUnit: "lbs",
  serviceDue: null,
  appointmentDate: "2026-03-18T09:00:00",
  appointmentEndDate: null,
  location: null,
  sic: "ONT",
  status: "ENRT",
  shipper: { id: 93322, name: "WEST COAST SUPPLY" },
  consignee: {
    id: 18452116,
    name: "METRO DISTRIBUTORS",
    address: "500 BROAD ST",
    city: "NEWARK",
    state: "NJ",
    zipCode: "07102",
  },
  tags: [TAG_LM],
  isPlanned: false,
  sicTimeZone: "America/New_York",
};

const shipment4 = {
  id: 136361100,
  proNumber: "2940365",
  pallets: 18,
  pieces: 36,
  handlingUnits: 12,
  weight: 21500,
  weightUnit: "lbs",
  serviceDue: "2026-03-17",
  appointmentDate: null,
  appointmentEndDate: null,
  location: "DYLT250821",
  sic: "ONT",
  status: "ARRV",
  shipper: { id: 93323, name: "NATIONAL LOGISTICS" },
  consignee: {
    id: 18452117,
    name: "HARBOR SUPPLIES",
    address: "800 HARBOR BLVD",
    city: "SECAUCUS",
    state: "NJ",
    zipCode: "07094",
  },
  tags: [],
  isPlanned: true,
  sicTimeZone: "America/New_York",
};

const shipment5 = {
  id: 136363750,
  proNumber: "2940358",
  pallets: 4,
  pieces: 8,
  handlingUnits: 3,
  weight: 3780,
  weightUnit: "lbs",
  serviceDue: "2026-03-19",
  appointmentDate: "2026-03-19T10:00:00",
  appointmentEndDate: "2026-03-19T12:00:00",
  location: "DYLT250823",
  sic: "ONT",
  status: "PLAN",
  shipper: { id: 93324, name: "SUNRISE FREIGHT" },
  consignee: {
    id: 18452118,
    name: "EMPIRE STATE GOODS",
    address: null,
    city: null,
    state: null,
    zipCode: "07306",
  },
  tags: [TAG_UC, TAG_WC],
  isPlanned: false,
  sicTimeZone: "America/New_York",
};

const shipment6 = {
  id: 136366200,
  proNumber: "2940341",
  pallets: 8,
  pieces: 16,
  handlingUnits: 6,
  weight: 9600,
  weightUnit: "lbs",
  serviceDue: null,
  appointmentDate: null,
  appointmentEndDate: null,
  location: null,
  sic: "ONT",
  status: "ENRT",
  shipper: { id: 93325, name: "TRI-STATE CARRIERS" },
  consignee: {
    id: 18452119,
    name: "NEWARK PORT AUTHORITY",
    address: "1 PORT ST",
    city: "NEWARK",
    state: "NJ",
    zipCode: "07102",
  },
  tags: [TAG_LM, TAG_RSHP, TAG_OSD],
  isPlanned: false,
  sicTimeZone: "America/New_York",
};

export const mockTripShipments = {
  default: {
    summary: {
      bills: 6,
      pallets: 51,
      pieces: 102,
      handlingUnits: 35,
      weight: 63560,
    },
    shipments: [
      shipment1,
      shipment2,
      shipment3,
      shipment4,
      shipment5,
      shipment6,
    ],
  },
};
